import { Link } from "react-router-dom";
import styled from "styled-components";

export const LinkTo = styled(Link)`
  text-decoration: none;
  /* font-weight: bold; */
  color: #ffff;
  
`;